module.exports = __webpack_public_path__ + "static/media/blue-blob.87ae700e.svg";